import { useAsync } from "react-use"
import { getOrganizationDetailsForImpersonator } from "data/apis/foundry"
import { getOriginalImpersonatorOrganization } from "@fuze/services-auth/dist/user-session"

// get the details of the *parent* organization if impersonating, otherwise get the active organization details
const useImpersonatorOrganization = () =>
  useAsync(async () => await getOrganizationDetailsForImpersonator(getOriginalImpersonatorOrganization()))

export default useImpersonatorOrganization
